import { Box, Typography, Card } from '@mui/material';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { useNavigate, useParams } from 'react-router-dom';
import { Fields } from 'src/ui-component/FormikFormLibrary/FormikTypes';
import { httpRequest } from 'src/services/httpRequest';
import toast from 'react-hot-toast';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { useEffect, useState } from 'react';

const DocumetnConfiguration: React.FC = () => {
  const navigate = useNavigate();
  const { townshipId } = useParams<{ townshipId: string }>();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const dispatch = useDispatch();
  const [permitOptions, setPermitOptions] = useState([]);

  const allFields: Fields[] = [
    {
      fieldName: 'selectPermit',
      fieldLabel: 'Select Permit',
      fieldType: 'select',
      options: permitOptions.map((options) => options.PermitName)
    },
    {
      fieldName: 'documentType',
      fieldLabel: 'Enter Document type',
      fieldType: 'tagInput',
      required: true,
      multipleTagInput: true
    }
  ];

  function handleCancel() {
    navigate(`/dashboard/${townshipId}`);
  }

  async function handleSubmit(val: any) {
    const body: {
      PermitID: number;
      TownshipID: number | string;
      DocumentTypes: any;
    } = {
      PermitID: permitOptions.find(
        (item) => item.PermitName === val.selectPermit
      ).PermitID,
      TownshipID: townshipId,
      DocumentTypes: val.documentType
    };
    const response = await httpRequest(
      'POST',
      `/configuration/documentConfiguration`,
      body
    );
    if (response.status === 'success') {
      toast.success(response?.message);
    } else {
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
  }

  // Extract permit names for the finance manager role
  useEffect(() => {
    if (userDetails && userDetails.TownshipPermits) {
      let permits = [];
      permits = userDetails.TownshipPermits.flatMap((department) =>
        department.Permits.map((permit) => ({
          PermitID: permit.PermitID,
          PermitName: permit.PermitName
        }))
      );
      setPermitOptions(permits);
    }
  }, [userDetails]);

  return (
    <Card>
      <Box m={{xs:1, sm:3}}>
        <Typography
          fontSize={"1.2rem"}
          fontWeight={"bold"}
          mb={{xs:2, sm:3}}
          color={useSelector((store: RootState) => store.theme.themeColor)}
        >
          Configure documents for permits
        </Typography>
        <FormikForm
          allFields={allFields}
          buttonTitle={['Cancel', 'Save']}
          formMethod={handleSubmit}
          handleOtherButton={handleCancel}
        />
      </Box>
    </Card>
  );
};

export default DocumetnConfiguration;
